/****
 * Utility function that converts the raw Microsoft (MSAL) account
 * information into the application's standardized Account model.
 *
 * Extracts user details such as ID, username, display name, and email
 * from the Microsoft authentication response while providing fallback
 * values when certain account properties are unavailable. This ensures
 * a consistent user account structure across the application.
 */
import type { AccountInfo } from "@azure/msal-browser";

import type { Account } from "./types";

export function normalizeAccount(accInfo: AccountInfo | any): Account {
  const displayName =
    accInfo?.name ||
    accInfo?.idTokenClaims?.name ||
    accInfo?.idTokenClaims?.preferred_username ||
    accInfo?.username ||
    "";
  const email = accInfo?.idTokenClaims?.email || accInfo?.username || "";
  return {
    id: accInfo?.homeAccountId || accInfo?.localAccountId,
    username: accInfo?.username || email,
    displayName,
    email,
  } as Account;
}
